import React from 'react';
import { Phone } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="relative bg-[#050505] border-t border-white/10" data-testid="footer">
      {/* Main Footer */}
      <div className="max-w-6xl mx-auto px-6 py-12">
        <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="relative w-8 h-8">
                <svg width="32" height="32" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8 32L20 8L32 32L28 32L20 18L12 32L8 32Z" fill="url(#gradient2)" />
                  <path d="M16 26L20 18L24 26L22 26L20 22L18 26L16 26Z" fill="#00E599" />
                  <defs>
                    <linearGradient id="gradient2" x1="8" y1="8" x2="32" y2="32" gradientUnits="userSpaceOnUse">
                      <stop stopColor="#00E599"/>
                      <stop offset="1" stopColor="#00D4FF"/>
                    </linearGradient>
                  </defs>
                </svg>
              </div>
              <div className="flex flex-col -space-y-1">
                <span className="text-lg font-headline font-bold text-[#F4F4F5]">Smart Growth</span>
                <span className="text-[10px] font-accent text-[#00E599] tracking-widest">TECH</span>
              </div>
            </div>
            <p className="text-sm text-[#A1A1AA] font-body leading-relaxed mb-4">
              AI automation built for the trades.
            </p>
            <a 
              href="tel:6027306385"
              className="inline-flex items-center gap-2 text-[#00E599] hover:text-[#00C985] transition-colors"
            >
              <Phone className="w-4 h-4" />
              <span className="text-sm font-body font-semibold">(602) 730-6385</span>
            </a>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm font-body font-semibold text-[#F4F4F5] mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><a href="#how-it-works" className="text-sm text-[#A1A1AA] hover:text-[#00E599] transition-colors font-body">How It Works</a></li>
              <li><a href="#integrations" className="text-sm text-[#A1A1AA] hover:text-[#00E599] transition-colors font-body">Integrations</a></li>
              <li><a href="#roi-calculator" className="text-sm text-[#A1A1AA] hover:text-[#00E599] transition-colors font-body">ROI Calculator</a></li>
              <li><a href="#pricing" className="text-sm text-[#A1A1AA] hover:text-[#00E599] transition-colors font-body">Pricing</a></li>
            </ul>
          </div>

          {/* Trades */}
          <div>
            <h3 className="text-sm font-body font-semibold text-[#F4F4F5] mb-4">Trades We Serve</h3>
            <ul className="space-y-2">
              <li><span className="text-sm text-[#A1A1AA] font-body">HVAC</span></li>
              <li><span className="text-sm text-[#A1A1AA] font-body">Plumbing</span></li>
              <li><span className="text-sm text-[#A1A1AA] font-body">Electrical</span></li>
              <li><span className="text-sm text-[#A1A1AA] font-body">Roofing</span></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-sm font-body font-semibold text-[#F4F4F5] mb-4">Get Started</h3>
            <p className="text-sm text-[#A1A1AA] font-body mb-3">
              Ready to stop missing leads?
            </p>
            <a 
              href="tel:6027306385"
              className="inline-block bg-[#00E599] hover:bg-[#00C985] text-[#050505] px-4 py-2 rounded-lg font-body font-semibold text-sm transition-all"
            >
              Call Us Now
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-xs text-[#A1A1AA] font-body">
            © 2026 Smart Growth Tech. All rights reserved.
          </p>
          <div className="flex gap-6">
            <a href="#" className="text-xs text-[#A1A1AA] hover:text-[#00E599] transition-colors font-body">Privacy Policy</a>
            <a href="#" className="text-xs text-[#A1A1AA] hover:text-[#00E599] transition-colors font-body">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
